export default __webpack_public_path__ + "static/media/endorsement-pedurenan-archery.ff78ad88.jpg";